import { WishlistProduct } from 'src/modules/vsf-magento-wishlist/components/Product'
export default {
  name: 'Product',
  methods: {
    // deprecated
    closeWishlist () {
      this.$store.commit('ui/setWishlist', false)
    }
  },
  mixins: [WishlistProduct]
}
